import React from "react";
import { CommentList } from "./CommentList";
import { CommentForm } from "./CommentForm";

export default function CollapsibleComments({
  target,
  objectId,
  isAuthenticated = Boolean(localStorage.getItem("access_token")),
  title = "Comments",
  defaultOpen = false,
}) {
  const [open, setOpen] = React.useState(defaultOpen);
  const [refreshKey, setRefreshKey] = React.useState(0);

  return (
    <section style={{ marginTop: 16 }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          background: 'rgba(255, 255, 255, 0.6)',
          border: "1px solid #e5e7eb",
          borderRadius: 8,
          padding: "10px 12px",
          cursor: "pointer",
          boxShadow: "0 6px 14px rgba(0,0,0,0.04)",
        }}
      >
        <span style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>{title}</span>
        <span style={{ fontSize: 12, color: "#6b7280" }}>{open ? "Hide" : "Show"}</span>
      </button>

      {open && (
        <div style={{ marginTop: 10 }}>
          {/* Key forces list reload after a post */}
          <CommentList key={refreshKey} target={target} objectId={objectId} />
          {isAuthenticated && (
            <div style={{ marginTop: 8 }}>
              <CommentForm
                target={target}
                objectId={objectId}
                onPosted={() => setRefreshKey((k) => k + 1)}
              />
            </div>
          )}
        </div>
      )}
    </section>
  );
}
